import React from 'react'
import reactCSS from 'reactcss'
import { ChromePicker } from 'react-color'
import Select from 'react-select';
import firebase from 'firebase';
import TimePicker from 'rc-time-picker';
import moment from 'moment';
import Modal from 'react-modal';
import MapaModal from './mapaModal';
import MapaRuta from './mapaRutasE';
import SearchBox from 'react-google-maps/lib/components/places/SearchBox'
import './estilo.css'
import carImg from '../../img/car.png';
import Alert from 'react-s-alert';
import { connect } from 'react-redux';
import { setRuta } from '../../actions'
import { sendLog } from './../../util'

const google = window.google;
const DirectionsService = new google.maps.DirectionsService();
const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        transform: 'translate(-50%, -50%)',
        width: '500px',
        height: '450px',
    }
};
class newRutes extends React.Component {
    constructor(props) {
        super(props);
        let coordsI = this.props.ruta.inicio === undefined ? '' : this.props.ruta.inicio.coordenadas.split(',');
        let coordsD = this.props.ruta.destino === undefined ? '' : this.props.ruta.destino.coordenadas.split(',');

        this.state = {
            displayColorPicker: false,
            color: this.props.ruta.coloRuta || '#503b2c',
            tipoViaje: this.props.ruta.tipoViaje || '',
            viajesT: [],
            puntosW: [],
            nombRuta: this.props.ruta.nombRuta || '',
            isParadas: false,
            rutas: [],
            coordenadas: [],
            recogimiento: this.props.ruta.recogimiento || false,
            paradasI: { coordenadas: { lat: Number(coordsI[0]) || 13.6988044, lng: Number(coordsI[1]) || -89.2507203 }, eta: 0, referencia: '', placeName: this.props.ruta.inicio !== undefined ? this.props.ruta.inicio.nombre : '' },
            paradasD: { coordenadas: { lat: Number(coordsD[0]) || 13.6988044, lng: Number(coordsD[1]) || -89.2507203 }, eta: 0, referencia: '', placeName: this.props.ruta.destino !== undefined ? this.props.ruta.destino.nombre : '' },
            showMarkerI: true,
            showMarkerD: true,
            orden: this.props.ruta.orden || false,
            tarifas: [],
            zonas: [],
            zona: this.props.ruta.zona || '',
            tarifa: this.props.ruta.tarifa || '',
            now: moment().hour(0).minute(0),
            isMulti: false,
            paradasW: [],
            aeropuerto: this.props.ruta.aeropuerto || false,
        };
        this.setMarkerG = this.setMarkerG.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentWillUnmount() { this.props.setRuta({}) }

    handleClick = () => {
        this.setState({ displayColorPicker: !this.state.displayColorPicker })
    };

    handleClose = () => {
        this.setState({ displayColorPicker: false })
    };

    handleChangeC = (color) => {
        this.setState({ color: color.hex })
    };

    changeTipo = (event) => {
        this.setState({ tipoViaje: event.value.key, isParadas: event.value.paradas });
    }

    changeTarifa = (event) => {
        this.setState({ tarifa: event.value });
    }

    changeZonas = (event) => {
        this.setState({ zona: event.value });
    }

    componentDidMount = () => {
        if (Array.isArray(this.props.ruta.paradas)) {
            this.loadParadas(this.props.ruta.paradas)
        }

        this.getTarifas();
        this.getZonasReparto();
        this.getTiposViaje();
        Modal.setAppElement('body');
    }

    loadParadas(paradas) {
        let puntosW = [];
        for (let i = 0; i < paradas.length; i++) {
            let coords = paradas[i].coordenadas.split(',');
            let id = 'paradas' + i;
            let coord = { lat: Number(coords[0]), lng: Number(coords[1]) };
            let acti = 'isActive' + i;
            let marke = 'showMarker' + i;
            let seconds = paradas[i].eta;
            let formatted = moment("2015-01-01").startOf('day').minutes(seconds).format('HH:mm');
            let split = formatted.split(':');
            let eta = moment().hour(Number(split[0])).minute(Number(split[1]))
            let minutos = Number((split[0] * 60)) + Number(split[1]);
            puntosW.push({ visible: true });
            this.setState({ [id]: { coordenadas: coord, eta: minutos, referencia: paradas[i].referencia, placeName: paradas[i].placeName, now: eta }, [acti]: false, [marke]: true, isParadas: true });
        }
        this.setState({ puntosW });
    }

    getTiposViaje() {
        firebase.database().ref('TiposViajes').once('value').then(snap => {
            let viajesT = [];
            snap.forEach(element => {
                let data = element.val();
                let obje = { label: data.nombre, value: { key: element.key, paradas: data.paradas } };
                viajesT.push(obje);
            })
            this.setState({ viajesT });
        })
    }

    getTarifas() {
        firebase.database().ref('TarifasAvianca').once('value').then(snap => {
            let tarifas = [];
            snap.forEach(element => {
                let data = element.val();
                tarifas.push({ label: data.tipo, value: element.key });
            })
            this.setState({ tarifas });
        })
    }

    getZonasReparto = () => {
        firebase.database().ref('ZonasReparto').once('value').then(snapE => {
            let zonas = [];
            snapE.forEach(element => {
                let data = element.val();
                zonas.push({ label: data.zona, value: element.key });
            })

            this.setState({ zonas });
        })
    }

    getTipoViaje() {
        let { viajesT, tipoViaje } = this.state;
        let viaje = viajesT.find(v => v.value.key === tipoViaje);
        return viaje;
    }

    getTarifa() {
        let { tarifas, tarifa } = this.state;
        let t = tarifas.find(v => v.value === tarifa);
        return t;
    }

    getZonaReparto() {
        let { zonas, zona } = this.state;

        let z = zonas.find(v => v.value === zona);
        return z;
    }

    addAnother = () => {
        this.darvalor(this.state.puntosW.length);
        let datos = { visible: true };
        this.setState({ puntosW: [...this.state.puntosW, datos] })
    }

    darvalor = (index) => {
        let id = 'paradas' + index;
        let coord = { lat: 13.6988044, lng: -89.2507203 };
        let acti = 'isActive' + index;
        let marke = 'showMarker' + index;
        this.setState({ [id]: { coordenadas: coord, eta: 0, referencia: '', placeName: '' }, [acti]: false, [marke]: false });
    }

    toggleModalG(index) {
        let active = 'isActive' + index;
        this.setState({ [active]: !this.state[active] })
    }

    handleChange(event, index) {
        let id = 'paradas' + index;
        this.setState({ [id]: { ...this.state[id], referencia: event.target.value } })
    }

    setMarkerG(e, index, para) {
        let lat2 = 0;
        let lng2 = 0;
        if (para === 1) {
            lat2 = e.lat();
            lng2 = e.lng();
        }
        else {
            lat2 = e.latLng.lat();
            lng2 = e.latLng.lng();
        }
        let marker = 'showMarker' + index;
        let coordenadas = { lat: Number(lat2), lng: Number(lng2) }
        let id = 'paradas' + index;

        fetch('https://maps.googleapis.com/maps/api/geocode/json?latlng=' + lat2 + ',' + lng2 + '&key=AIzaSyBWSezH7j1VKwfE36I0gsaaL8UwZh7cT0M')
            .then(response => response.json())
            .catch(error => error)
            .then(responseJSON => {
                let nombreP = responseJSON.results[0].formatted_address;
                this.setState({ [id]: { ...this.state[id], coordenadas: coordenadas, placeName: nombreP }, [marker]: true })
            })
    }


    onPlacesBusqueda = (index) => {
        const places = this.searchBox.getPlaces();
        const bounds = new google.maps.LatLngBounds();
        places.forEach(place => {
            if (place.geometry.viewport) {
                bounds.union(place.geometry.viewport)
            } else {
                bounds.extend(place.geometry.location)
            }
        });
        const nextMarkers = places.map(place => ({
            position: place.geometry.location,
        }));
        let e = nextMarkers[0].position;
        this.setMarkerG(e, index, 1)
    }

    onTimeChange(options, index) {
        let hora = moment(options, "hmm").format("HH:mm")
        let data = hora.split(':');
        let id = 'paradas' + index;
        let minutos = Number((data[0] * 60)) + Number(data[1]);
        this.setState({ [id]: { ...this.state[id], eta: minutos } })
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({ [name]: value });
    }

    handleParadaDChange(event) {
        const value = event.target.value;
        this.setState({
            paradasD: {
                ...this.state.paradasD,
                placeName: value
            }
        });
    }

    handleParadaIChange(event) {
        const value = event.target.value;
        this.setState({
            paradasI: {
                ...this.state.paradasI,
                placeName: value
            }
        });
    }

    verRuta = async () => {
        let { puntosW } = this.state;
        let paradasW = [];
        let inicio = this.state['paradasI'];
        let destino = this.state['paradasD'];
        paradasW.push({
            location: new google.maps.LatLng(inicio.coordenadas.lat, inicio.coordenadas.lng),
            name: inicio.referencia
        })
        for (let index = 0; index < puntosW.length; index++) {
            let id = 'paradas' + index;
            let coord = this.state[id];
            if (coord.coordenadas.lat !== 13.6988044 && coord.coordenadas.lng !== -89.2507203) {
                paradasW.push({
                    location: new google.maps.LatLng(coord.coordenadas.lat, coord.coordenadas.lng),
                    name: coord.referencia
                })
            }
        }
        paradasW.push({
            location: new google.maps.LatLng(destino.coordenadas.lat, destino.coordenadas.lng),
            name: destino.referencia
        })
        let tama = puntosW.length;
        if (tama > 23) {
            let resto = tama % 23;
            let divisor = tama / 23;
            let inicio = 0;
            let inicioD = '';
            let destinoD = '';
            let rutasA = [];
            for (let indexP = 1; indexP <= (divisor + 1); indexP++) {
                let paradas2 = [];
                for (let index = inicio; index < (23 * indexP); index++) {
                    let id = 'paradas' + index;
                    let coord = this.state[id];
                    if (coord !== undefined && coord.coordenadas.lat !== 13.6988044 && coord.coordenadas.lng !== -89.2507203) {
                        paradas2.push({
                            location: new google.maps.LatLng(coord.coordenadas.lat, coord.coordenadas.lng),
                            stopover: true,
                        })
                        inicio++;
                    }
                }
                if (indexP === 1) {
                    inicioD = this.state['paradasI'];
                    let id = 'paradas' + (inicio - 1);
                    let coord = this.state[id];
                    let valor = await this.getRoute(inicioD.coordenadas, coord.coordenadas, paradas2);
                    inicioD = coord;
                    rutasA.push(valor)
                } else {
                    let numero = String(divisor).charAt(0);
                    if (indexP !== (Number(numero) + 1)) {
                        let id = 'paradas' + (inicio - 1);
                        let coord = this.state[id];
                        let valor = await this.getRoute(inicioD.coordenadas, coord.coordenadas, paradas2);
                        rutasA.push(valor)
                        inicioD = coord;
                    }
                    else {
                        destinoD = this.state['paradasD']
                        let valor = await this.getRoute(inicioD.coordenadas, destinoD.coordenadas, paradas2);
                        rutasA.push(valor)
                    }
                }
            }
            this.setState({ coordenadas: rutasA, isMulti: true, paradasW })
            return rutasA
        }
        else {
            let rutas = [];
            let rutasB = [];
            let inicio = this.state['paradasI'];
            let destino = this.state['paradasD'];
            rutas.push(inicio)
            rutas.push(destino)
            for (let index = 0; index < puntosW.length; index++) {
                let id = 'paradas' + index;
                let coord = this.state[id];
                if (coord.coordenadas.lat !== 13.6988044 && coord.coordenadas.lng !== -89.2507203) {
                    rutas.push(coord)
                    rutasB.push({
                        location: new google.maps.LatLng(coord.coordenadas.lat, coord.coordenadas.lng),
                        stopover: true
                    })
                }
            }
            this.setState({ rutas });
            let valor = [];
            valor.push(await this.getRoute(inicio.coordenadas, destino.coordenadas, rutasB));
            this.setState({ coordenadas: valor, isMulti: false, paradasW })
            return valor
        }
    }

    getRoute = (inicio, destino, paradas) => {
        let viaje = '';
        viaje = new Promise((resolve, reject) => {
            DirectionsService.route({
                origin: new google.maps.LatLng(inicio.lat, inicio.lng),
                destination: new google.maps.LatLng(destino.lat, destino.lng),
                waypoints: paradas,
                travelMode: google.maps.TravelMode.DRIVING,
            }, (result, status) => {
                if (status === google.maps.DirectionsStatus.OK) {
                    resolve(result)
                } else {
                    reject(result);
                }
            })
        })

        return viaje;
    }

    remove = (sele) => {
        let { puntosW } = this.state;
        let data = [];
        for (let index = 0; index < puntosW.length; index++) {
            const element = this.state.puntosW[index];
            if (sele === index) {
                let id = 'paradas' + index;
                let coord = { lat: 13.6988044, lng: -89.2507203 };
                element.visible = false;
                this.setState({ [id]: { coordenadas: coord, eta: 0, referencia: '', placeName: '' } });
            }
            data.push(element);
        }
        this.setState({ puntosW: data })
    }

    actualizarRutas = async (keyRuta, ruta) => {
        try {

            delete ruta.georeferencia;
            const snap = await firebase.database().ref('ProgramacionDia').orderByChild('estado').equalTo('Pendiente').once('value');
            const data = snap.val();
            for (const key in data) {
                if (data[key].ruta == keyRuta)
                    await firebase.database().ref().child('ProgramacionDia').child(key).update({ rutaF: ruta });
            }
        } catch (error) {
            console.log('error :', error);
        }
    }

    saveData = async () => {
        let { nombRuta, color, tipoViaje, puntosW, orden, tarifa, zona, aeropuerto } = this.state;
        if (nombRuta !== '') {
            let coordI = this.state['paradasI'].coordenadas.lat + ',' + this.state['paradasI'].coordenadas.lng;
            let coordD = this.state['paradasD'].coordenadas.lat + ',' + this.state['paradasD'].coordenadas.lng;
            let paradas = [];
            for (let index = 0; index < puntosW.length; index++) {
                let id = 'paradas' + index;
                if (this.state[id].placeName !== '') {
                    let coordI = this.state[id].coordenadas.lat + ',' + this.state[id].coordenadas.lng;
                    paradas.push({
                        coordenadas: coordI,
                        eta: this.state[id].eta,
                        placeName: this.state[id].placeName,
                        referencia: this.state[id].referencia
                    })
                }
            }

            let json = await this.verRuta();
            var georeferencia = JSON.parse(JSON.stringify(json));

            let ruta = {
                nombRuta,
                coloRuta: color,
                tipoViaje,
                paradas,
                inicio: { coordenadas: coordI, nombre: this.state['paradasI'].placeName },
                destino: { coordenadas: coordD, nombre: this.state['paradasD'].placeName },
                estado: 1,
                orden,
                tarifa,
                zona,
                aeropuerto,
                georeferencia
            };

            if (this.props.ruta.key === undefined) {
                const idKey = firebase.database().ref().child('Rutas').push(ruta).key;
                sendLog({ tipo: 'ruta_nueva', informacion_extra: { ruta: idKey } });
                Alert.success('Datos guardados correctamente', {
                    effect: 'genie',
                    position: 'bottom-right',
                    timeout: 2000
                });
            }
            else {
                await firebase.database().ref().child('Rutas').child(this.props.ruta.key).set(ruta);
                this.actualizarRutas(this.props.ruta.key, ruta);
                sendLog({ tipo: 'ruta_editada', informacion_extra: { ruta: this.props.ruta.key } });
                Alert.success('Datos modificados correctamente', {
                    effect: 'genie',
                    position: 'bottom-right',
                    timeout: 2000
                });
            }
            this.props.history.goBack();
        } else {
            Alert.warning('Proporcione nombre de la ruta', {
                effect: 'genie',
                position: 'bottom-right',
                timeout: 2000
            });
        }
    }

    openAndSee = () => {
        this.verRuta();
        this.toggleModalG('T');
    }

    render() {
        const styles = reactCSS({
            'default': {
                color: {
                    width: '100%',
                    height: '34px',
                    borderRadius: '2px',
                    background: this.state.color
                },
                swatch: {
                    padding: '2px',
                    background: '#fff',
                    borderRadius: '1px',
                    boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                    cursor: 'pointer',
                },
                popover: {
                    position: 'absolute',
                    zIndex: '2',
                },
                cover: {
                    position: 'fixed',
                    top: '0px',
                    right: '0px',
                    bottom: '0px',
                    left: '0px',
                },
            },
        });
        let { viajesT, puntosW, isParadas, rutas, coordenadas, tarifas, zonas, isMulti, paradasW } = this.state;

        return (
            <div className='container'>
                <div style={{ marginLeft: '17.5%' }} className="row header-margin-top">
                    <div className="col-md-1">
                        <img src={carImg} className="img-fluid m-top-img" />
                    </div>
                    <div className="col-md-11">
                        <h3 className="title-blue">Ruta Nueva</h3>
                        <span className="text-info">Crea una nueva ruta ingresando la información en los campos.</span>
                    </div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', paddingTop: 25 }}>
                    <div style={{ width: '65%', height: 'auto' }}>
                        <div className="col-12 col-md-12">
                            <div className="row">
                                <div className="col-4 col-md-4">
                                    <div className="form-group">
                                        <label>Tipo de viaje</label>
                                        <Select value={this.getTipoViaje()} onChange={this.changeTipo} options={viajesT} />
                                    </div>
                                </div>
                                <div className="col-4 col-md-4 form-check" style={{ top: '39px', left: '30px' }}>
                                    <div className="form-group row">
                                        <label htmlFor='recogimiento'>Viaje de recogimiento</label>
                                        <input type="checkbox" onChange={this.handleInputChange} name='orden' className="form-check-input" id="orden" checked={this.state.orden} />
                                    </div>
                                </div>
                                <div className="col-4 col-md-4 form-check" style={{ top: '39px', left: '30px' }}>
                                    <div className="form-group row">
                                        <label htmlFor='aeropuerto'>Desde Aeropuerto</label>
                                        <input type="checkbox" onChange={this.handleInputChange} name='aeropuerto' className="form-check-input" id="aeropuerto" checked={this.state.aeropuerto} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-12">
                            <div className="row">
                                <div className="col-12 col-md-8">
                                    <div className="form-group">
                                        <label>Nueva ruta</label>
                                        <input name="nombRuta" onChange={this.handleInputChange} type="text" defaultValue={this.state.nombRuta} className="form-control" placeholder="Nombre de ruta" />
                                    </div>
                                </div>
                                <div className="col-12 col-md-4">
                                    <div className="form-group">
                                        <label>Color</label>
                                        <div style={styles.swatch} onClick={this.handleClick}>
                                            <div style={styles.color} />
                                        </div>
                                        {this.state.displayColorPicker ? <div style={styles.popover}>
                                            <div style={styles.cover} onClick={this.handleClose} />
                                            <ChromePicker disableAlpha={true} color={this.state.color} onChange={this.handleChangeC} />
                                        </div> : null}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-12">
                            <div className="row">
                                <div className="col-6 col-md-6">
                                    <div className="form-group">
                                        <label>Tarifa</label>
                                        <Select value={this.getTarifa()} placeholder="Seleccione un tarifa" onChange={this.changeTarifa} options={tarifas} />
                                    </div>
                                </div>
                                <div className="col-6 col-md-6">
                                    <div className="form-group">
                                        <label>Zona</label>
                                        <Select value={this.getZonaReparto()} placeholder="Seleccione una zona" onChange={this.changeZonas} options={zonas} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-12">
                            <div className="form-group">
                                <label>Origen</label>
                                <input type="text" defaultValue={this.state['paradasI'].placeName} onClick={() => this.toggleModalG('I')} className="form-control" readOnly={true} placeholder="Ingrese ubicación" />
                            </div>
                            <div className="form-group">
                                <label>Destino</label>
                                <input type="text" defaultValue={this.state['paradasD'].placeName} onClick={() => this.toggleModalG('D')} className="form-control" readOnly={true} placeholder="Ingrese ubicación" />
                            </div>
                        </div>
                        <div className="col-12 col-md-12">
                            <div className="row">
                                <div className="col-12 col-md-3 align-self-end">
                                    <button onClick={() => this.props.history.goBack()} type="button" className="btn btn-flat float-left">Regresar</button>
                                </div>
                                <div className="col-12 col-md-3">
                                    <button onClick={this.openAndSee} type="button" className="btn btn-orange-ligth float-left">Ver ruta</button>
                                </div>
                                <div className="col-12 col-md-3">
                                    <button onClick={this.saveData} type="button" className="btn btn-green-ligth">{(this.props.ruta.key) ? 'Modificar ruta' : 'Crear nueva ruta'}</button>
                                </div>
                                {isParadas &&
                                    <div className="col-12 col-md-3 ">
                                        <button onClick={this.addAnother} type="button" className="btn btn-blue-ligth ">Añadir punto</button>
                                    </div>
                                }
                            </div>
                            {isParadas &&
                                <div>
                                    <br />
                                    <p style={{ fontFamily: 'lato', fontSize: '16', fontWeight: 'bold', textAlign: 'center', }}>Puntos / Paradas</p>
                                    <hr />

                                    {puntosW.map((snap, index) => {
                                        if (snap.visible === true) {
                                            return (

                                                <div key={'punto' + index} style={{ marginBottom: 25, width: '100%', height: 'auto', borderLeftColor: '#1DA0FF', borderLeftWidth: 2, borderLeftStyle: 'solid', paddingLeft: 20 }}>
                                                    <div className="form-group">
                                                        <label style={{ cursor: 'pointer', fontFamily: 'lato', fontWeight: 'bold' }}>Destino</label>
                                                        <label onClick={() => this.remove(index)} style={{ cursor: 'pointer', fontFamily: 'lato', fontWeight: 'bold', marginLeft: '2%' }} className='float-right'>Eliminar</label>
                                                        <label onClick={() => this.addAnother()} style={{ cursor: 'pointer', fontFamily: 'lato', fontWeight: 'bold', textDecoration: 'underline' }} className='float-right'>Agregar Punto</label>
                                                        <input type="text" defaultValue={this.state['paradas' + index].placeName} onClick={() => this.toggleModalG(index)} className="form-control" readOnly={true} placeholder="Ingrese ubicación" />
                                                    </div>
                                                    <div className="form-group">
                                                        <label>Dirección / Referencia</label>
                                                        <input defaultValue={this.state['paradas' + index].referencia} onChange={(event) => this.handleChange(event, index)} type="text" className="form-control" placeholder="Dirección / Referencia" />
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-12 col-md-6">
                                                            <label style={{ width: '100%' }}>Tiempo hasta punto</label>
                                                            <TimePicker
                                                                showSecond={false}
                                                                defaultValue={this.state['paradas' + index].now}
                                                                style={{ width: '100%' }}
                                                                onChange={(options) => this.onTimeChange(options, index)}
                                                                showSecond={false}
                                                                inputReadOnly />
                                                        </div>
                                                    </div>
                                                    <Modal key={'modal' + index} isOpen={this.state['isActive' + index]} onRequestClose={() => this.toggleModalG(index)} style={customStyles}>
                                                        <MapaModal
                                                            googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyBWSezH7j1VKwfE36I0gsaaL8UwZh7cT0M&v=3.exp&libraries=geometry,drawing,places"
                                                            loadingElement={<div style={{ height: '600px', }} />}
                                                            containerElement={<div />}
                                                            mapElement={<div style={{ height: '300px', width: '450px' }} />}
                                                            setMarker={(e) => this.setMarkerG(e, index, 0)}
                                                            coordenadas={this.state['paradas' + index].coordenadas}
                                                            showMarker={this.state['showMarker' + index]} >
                                                            <SearchBox
                                                                ref={refs => this.searchBox = refs}
                                                                onPlacesChanged={() => this.onPlacesBusqueda(index)}
                                                                bounds={new google.maps.LatLngBounds(new google.maps.LatLng(Number(13.6988044), Number(-89.2507203)))}
                                                                controlPosition={1}>
                                                                <input
                                                                    type="text"
                                                                    defaultValue="San Salvador"
                                                                    className="validate"
                                                                    style={{
                                                                        boxSizing: `border-box`,
                                                                        border: `1px solid transparent`,
                                                                        width: `35%`,
                                                                        height: `40px`,
                                                                        marginTop: '10px',
                                                                        padding: `0 12px`,
                                                                        borderRadius: `3px`,
                                                                        boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
                                                                        fontSize: `14px`,
                                                                        fontColor: `black`,
                                                                        outline: `none`,
                                                                        textOverflow: `ellipses`,
                                                                    }}
                                                                />
                                                            </SearchBox>
                                                        </MapaModal>
                                                        <div className="form-group">
                                                            <label>Direccion</label>
                                                            <input type="text" className="form-control" defaultValue={this.state['paradas' + index].placeName} readOnly={true} placeholder="Direccion" />
                                                        </div>
                                                        <div className="form-group col-md-4 ml-auto">
                                                            <button onClick={() => this.toggleModalG(index)} className="btn btn-green">Aceptar</button>
                                                        </div>
                                                    </Modal>
                                                </div>
                                            )
                                        }
                                    })}
                                </div>
                            }

                            <Modal key={'modalI'} isOpen={this.state['isActiveI']} onRequestClose={() => this.toggleModalG('I')} style={customStyles}>
                                <MapaModal
                                    googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyBWSezH7j1VKwfE36I0gsaaL8UwZh7cT0M&v=3.exp&libraries=geometry,drawing,places"
                                    loadingElement={<div style={{ height: '600px', }} />}
                                    containerElement={<div />}
                                    mapElement={<div style={{ height: '300px', width: '450px' }} />}
                                    setMarker={(e) => this.setMarkerG(e, 'I', 0)}
                                    coordenadas={this.state['paradasI'].coordenadas}
                                    showMarker={this.state['showMarkerI']}
                                >
                                    <SearchBox
                                        ref={refs => this.searchBox = refs}
                                        onPlacesChanged={() => this.onPlacesBusqueda('I')}
                                        bounds={new google.maps.LatLngBounds(new google.maps.LatLng(Number(13.6988044), Number(-89.2507203)))}
                                        controlPosition={1}>
                                        <input
                                            type="text"
                                            defaultValue="San Salvador"
                                            className="validate"
                                            style={{
                                                boxSizing: `border-box`,
                                                border: `1px solid transparent`,
                                                width: `35%`,
                                                height: `40px`,
                                                marginTop: '10px',
                                                padding: `0 12px`,
                                                borderRadius: `3px`,
                                                boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
                                                fontSize: `14px`,
                                                fontColor: `black`,
                                                outline: `none`,
                                                textOverflow: `ellipses`,
                                            }}
                                        />
                                    </SearchBox>
                                </MapaModal>
                                <div className="form-group">
                                    <label>Direccion</label>
                                    <input name='paradasI' type="text" className="form-control" onChange={this.handleParadaIChange.bind(this)} defaultValue={this.state['paradasI'].placeName} placeholder="Direccion" />
                                </div>
                                <div className="form-group col-md-4 ml-auto">
                                    <button onClick={() => this.toggleModalG('I')} className="btn btn-green">Aceptar</button>
                                </div>
                            </Modal>

                            <Modal key={'modalD'} isOpen={this.state['isActiveD']} onRequestClose={() => this.toggleModalG('D')} style={customStyles}>
                                <MapaModal
                                    googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyBWSezH7j1VKwfE36I0gsaaL8UwZh7cT0M&v=3.exp&libraries=geometry,drawing,places"
                                    loadingElement={<div style={{ height: '600px', }} />}
                                    containerElement={<div />}
                                    mapElement={<div style={{ height: '300px', width: '450px' }} />}
                                    setMarker={(e) => this.setMarkerG(e, 'D', 0)}
                                    coordenadas={this.state['paradasD'].coordenadas}
                                    showMarker={this.state['showMarkerD']} >
                                    <SearchBox
                                        ref={refs => this.searchBox = refs}
                                        onPlacesChanged={() => this.onPlacesBusqueda('D')}
                                        bounds={new google.maps.LatLngBounds(new google.maps.LatLng(Number(13.6988044), Number(-89.2507203)))}
                                        controlPosition={1}>
                                        <input
                                            type="text"
                                            defaultValue="San Salvador"
                                            className="validate"
                                            style={{
                                                boxSizing: `border-box`,
                                                border: `1px solid transparent`,
                                                width: `35%`,
                                                height: `40px`,
                                                marginTop: '10px',
                                                padding: `0 12px`,
                                                borderRadius: `3px`,
                                                boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
                                                fontSize: `14px`,
                                                fontColor: `black`,
                                                outline: `none`,
                                                textOverflow: `ellipses`,
                                            }}
                                        />
                                    </SearchBox>
                                </MapaModal>
                                <div className="form-group">
                                    <label>Direccion</label>
                                    <input type="text" className="form-control" defaultValue={this.state['paradasD'].placeName} name='paradasD' onChange={this.handleParadaDChange.bind(this)} placeholder="Direccion" />
                                </div>
                                <div className="form-group col-md-4 ml-auto">
                                    <button onClick={() => this.toggleModalG('D')} className="btn btn-green">Aceptar</button>
                                </div>
                            </Modal>

                            <Modal key={'modalT'} isOpen={this.state['isActiveT']} onRequestClose={() => this.toggleModalG('T')} style={customStyles}>
                                <MapaRuta
                                    googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyBWSezH7j1VKwfE36I0gsaaL8UwZh7cT0M&v=3.exp&libraries=geometry,drawing,places"
                                    loadingElement={<div style={{ height: '600px', }} />}
                                    containerElement={<div />}
                                    mapElement={<div style={{ height: '400px', width: '450px' }} />}
                                    markers={rutas}
                                    direccion={coordenadas}
                                    isMulti={isMulti}
                                    paradasW={paradasW}>
                                </MapaRuta>
                            </Modal>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        ruta: state.ruta
    }
}

export default connect(mapStateToProps, { setRuta })(newRutes);


// WEBPACK FOOTER //
// ./src/Components/Rutas/newRutes.js